import "core-js/stable";
import Api from './app/api/api.js';

window.cfApi = Api;